module.exports = __webpack_public_path__ + "img/memory1-expl.a2ecaa24.png";